var Handlebars = require("../../../../../../node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div id=\"fr-search-disabled-view\">\n    <span class=\"icon icon-attention-circled\"></span>\n    User lacks permission to create any notes.\n</div>";
},"useData":true});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/searchNotAllowedView/template.hbs
 ** module id = 652
 ** module chunks = 0
 **/